import { deleteObject, getDownloadURL, ref, uploadBytes } from 'firebase/storage';
import { storage } from '../firebase';

const STORAGE_URL_MARKERS = ['firebasestorage.googleapis.com', 'firebasestorage.app'];

export function isFirebaseStorageDownloadUrl(url: string): boolean {
  const u = url.trim();
  return STORAGE_URL_MARKERS.some((m) => u.includes(m));
}

/** Même arbo que l’app mobile : `candidatures/{userId}/{candidatureKey}/{uuid}.pdf` */
export async function uploadCandidaturePdf(
  userId: string,
  candidatureKey: string,
  file: File
): Promise<string> {
  const uid = typeof crypto !== 'undefined' && crypto.randomUUID
    ? crypto.randomUUID()
    : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  const safeName = `${uid}.pdf`;
  const path = `candidatures/${userId}/${candidatureKey}/${safeName}`;
  const r = ref(storage, path);
  await uploadBytes(r, file, { contentType: file.type || 'application/pdf' });
  return getDownloadURL(r);
}

export async function deleteCandidatureStorageFileByUrl(url: string): Promise<void> {
  const u = url.trim();
  if (!u || !isFirebaseStorageDownloadUrl(u)) return;
  try {
    await deleteObject(ref(storage, u));
  } catch (e: unknown) {
    const code = (e as { code?: string })?.code;
    if (code === 'storage/object-not-found') return;
    throw e;
  }
}
